import { styled } from "theme/default/styled";
import { setFlexDFAIC } from "theme/setter/setFlexValues/setFlexDFAIC";
import { setFlexFDC } from "theme/setter/setFlexValues/setFlexFDC";

export const SForgotPasswordForm = styled.form`
  margin: auto 0;

  ${setFlexDFAIC};
  ${setFlexFDC};
`;
